import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons

import Hidden from "@material-ui/core/Hidden";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeroCard from "components/HeroCard/HeroCard.jsx";
import JoinModal from "components/JoinModal/JoinModal.jsx";

// core components
import pictureHeroStyle from "assets/jss/material-kit-react/components/pictureHeroStyle.jsx";

function PictureHero({ ...props }) {
  const {
    id,
    classes,
    className,
    children,
    plain,
    carousel,
    hero,
    logo,
    Image,
    image,
    imageRight,
    imageLeft,
    BackgroundImage,
    backgroundImageTop,
    backgroundImageBottom,
    waitlistBar,
    listIds,
    ...rest } = props;
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardPlain]: plain,
    [classes.cardCarousel]: carousel,
    [className]: className !== undefined
  });
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgFluid
  );

  function Logo({...props}) {
    const {
      logo
    } = props;

    if(logo) {
      return (
          <div className={classes.logoContainer}>
            <img className={classes.logo} src={logo} />
          </div>
      )
    } else {
      return null;
    }
  }

  function WaitlistBar({...props}) {
    const {
      classes,
      waitlistBar
    } = props;

    if (waitlistBar) {
      return (
        <div className={classes.waitlistBar}>
          <JoinModal fullWidthButton buttonText="Coming Soon. Join our waitlist." listIds={listIds}/>
        </div>
      );
    }

    return null;
  }

  function ImageLeftComponent ({ ...props }) {
    const {
      imageRight,
      logo,
      backgroundImageTop,
      backgroundImageBottom,
    } = props;

    const backgroundPositionClass = classNames(
      backgroundImageTop ? classes.backgroundImageTop : {}, 
      backgroundImageBottom ? classes.backgroundImageBottom : {},
      );
    const PictureImage = Image ? <Image className={classNames(classes.img, imageClasses, classes.borderRadius, backgroundPositionClass)}/> : false;
    const PictureBackground = BackgroundImage ? <BackgroundImage className={classNames(classes.img, imageClasses, classes.borderRadius, backgroundPositionClass)}/> : false;
    const Picture = PictureImage ? PictureImage : PictureBackground;

    if (imageLeft) {
      return (
        <GridItem xs={12} md={5}>
        {Picture}
        </GridItem>
      )
    } else {
      return (
        <Hidden mdUp>
          <GridItem xs={12} md={5}>
        {Picture}

          </GridItem>
        </Hidden>
      )
    }
  }

  function ImageRightComponent ({ ...props }) {
    const {
      imageRight,
      logo,
      backgroundImageTop,
      backgroundImageBottom,
    } = props;

    const backgroundPositionClass = classNames(
      backgroundImageTop ? classes.backgroundImageTop : {}, 
      backgroundImageBottom ? classes.backgroundImageBottom : {},
      );
    const PictureImage = Image ? <Image classes={classes} className={classNames(classes.img, imageClasses, classes.borderRadius, backgroundPositionClass)}/> : false;
    const PictureBackground = BackgroundImage ? <BackgroundImage className={classNames(classes.img, imageClasses, classes.borderRadius, backgroundPositionClass)}/> : false;
    const Picture = PictureImage ? PictureImage : PictureBackground;

    if (imageRight) {
      return (
        <Hidden smDown>
          <GridItem xs={12} md={5}>
        {Picture}
          </GridItem>
        </Hidden>
      )
    } else {
      return null;
    }
  }

  return (
    <section id={id} className={classNames(classes.container, className)} {...rest}>
      <GridContainer justify="space-around">
        <ImageLeftComponent imageLeft={imageLeft} logo={logo} backgroundImageTop={backgroundImageTop} backgroundImageBottom={backgroundImageBottom}/>
        <GridItem xs={12} md={7} className={classes.heroContainer}>
          <WaitlistBar classes={classes} waitlistBar={waitlistBar}/>
          <HeroCard hero={hero} className={classNames(classes.heroCard, classes.heroContainer)}/>
        </GridItem>
        <ImageRightComponent imageRight={imageRight} logo={logo} backgroundImageTop={backgroundImageTop} backgroundImageBottom={backgroundImageBottom}/>
      </GridContainer>
    </section>
  );
}

PictureHero.defaultProps = {
  hero: {
    "section-title": "section title",
    title: "title",
    subtitle: "subtitle",
    text: ["text", "more text"]
  },
  image: "assets/img/organize.jpg",
  imageLeft: false,
  imageRight: false,
  backgroundImageTop: false
};

PictureHero.propTypes = {

};

export default withStyles(pictureHeroStyle)(PictureHero);